import type { DiagramSpec } from "../types"

/** Left-to-right sequential pipeline — reads like a conveyor belt */
export const lrPipeline: DiagramSpec = {
  id: "lr-pipeline",
  name: "LR: Talking Head Pipeline",
  description: "Sequential left-to-right workflow",
  layers: [
    { id: "input", name: "Input", color: "#6366f1" },
    { id: "process", name: "Process", color: "#f59e0b" },
    { id: "output", name: "Output", color: "#10b981" },
  ],
  nodes: [
    {
      id: "script",
      label: "Script",
      layer: "input",
      rank: 0,
      description: "Claude Sonnet generates the script from a topic prompt",
    },
    {
      id: "voice",
      label: "Voice",
      layer: "process",
      rank: 1,
      description: "ElevenLabs synthesizes speech from the script",
    },
    {
      id: "avatar",
      label: "Avatar",
      layer: "process",
      rank: 2,
      description: "Seedance generates video from audio + reference image",
    },
    {
      id: "edit",
      label: "Auto-Edit",
      layer: "process",
      rank: 3,
      description: "NanoBanana adds captions, transitions, B-roll",
    },
    {
      id: "render",
      label: "Render",
      layer: "output",
      rank: 4,
      description: "Final MP4 export with watermark + metadata",
    },
    { id: "upload", label: "Upload", layer: "output", rank: 5, description: "Publish to YouTube, TikTok, Instagram" },
  ],
  edges: [
    { id: "e1", source: "script", target: "voice" },
    { id: "e2", source: "voice", target: "avatar" },
    { id: "e3", source: "avatar", target: "edit" },
    { id: "e4", source: "edit", target: "render" },
    { id: "e5", source: "render", target: "upload" },
  ],
  views: [{ id: "main", name: "Pipeline", layout: "LR" }],
  defaultView: "main",
  preferences: {
    nodeWidth: 200,
    rankSpacing: 180,
    showLayerBands: true,
    edgeStyle: "smoothstep",
  },
}
